module.exports = "<div\n   [ngClass]=\"bgColor\"\n   class=\"card card-inverse h-100\">\n   <div class=\"card-block p-2\">\n      <h3 class=\"card-title text-mono\"><strong>{{fundsService.funds.balance | currency:'USD':true }}</strong></h3>\n      <div style=\"padding-top: 5px\">({{profitPerHour | currency: 'USD':true}}/hr)</div>\n   </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/company-digest/funds-digest/funds-digest.component.html
// module id = ./src/app/web/game/management/company-digest/funds-digest/funds-digest.component.html
// module chunks = main